export default "__VITE_ASSET__7a8c6b72__"